import { Link } from "react-router-dom";
import { useSettings } from "../hooks/useSettings";
import { WAIVER_PDF } from "../lib/constants";

export const Footer = () => {
  const STUDIO = useSettings();
  return (
    <footer data-testid="footer" className="relative bg-black border-t border-neutral-900 pt-16 pb-10">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <a href="#home" className="font-script text-6xl sm:text-8xl neon-text leading-none block mb-10">
          Sculpt Fusion
        </a>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 border-t border-neutral-900 pt-10">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-neutral-400 mb-3">Studio</p>
            <p className="text-sm text-neutral-400">{STUDIO.address}</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-neutral-400 mb-3">Contact</p>
            <p className="text-sm text-neutral-400">{STUDIO.phone}</p>
            <p className="text-sm text-neutral-400 break-all">{STUDIO.email}</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-neutral-400 mb-3">Explore</p>
            <ul className="flex flex-col gap-1 text-sm text-neutral-400">
              <li><a href="#schedule" className="hover:text-neon transition-colors">Schedule</a></li>
              <li><a href="#pricing" className="hover:text-neon transition-colors">Pricing</a></li>
              <li><a href="#about" className="hover:text-neon transition-colors">About</a></li>
              <li><Link to="/policies" data-testid="footer-policies-link" className="hover:text-neon transition-colors">Policies</Link></li>
              <li><Link to="/accessibility" data-testid="footer-accessibility-link" className="hover:text-neon transition-colors">Accessibility</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-neon transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-neon transition-colors">Terms of Service</Link></li>
              <li><a href={WAIVER_PDF} target="_blank" rel="noreferrer" data-testid="footer-waiver-link" className="hover:text-neon transition-colors">Liability Waiver</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-neutral-400 mb-3">Social</p>
            <p className="text-sm text-neutral-400">{STUDIO.instagram}</p>
          </div>
        </div>
        <p className="mt-10 text-xs text-neutral-400 uppercase tracking-[0.2em]">
          © {new Date().getFullYear()} Sculpt Fusion Pilates. Sweat. Sculpt. Repeat.
        </p>
      </div>
    </footer>
  );
};
